import type { RsiVerificationStatus } from "@/types";

/** Manual review statuses an admin can set (annotation only). */
export const STATUSES: RsiVerificationStatus[] = ["VERIFIED_CORRECT", "VERIFIED_INCORRECT", "NEEDS_REVIEW", "IGNORED"];

/** Column order keeps Net P&L and the (total) R-multiple inside the first
 *  screenful; detail columns follow. Every cell is `nowrap`. */
export const COLUMNS: [string, string | null][] = [
  ["#", "trade_no"], ["Side", "direction"], ["Entry (IST)", "entry_time"], ["Entry", null], ["SL", null], ["Target", null],
  ["Exit (IST)", null], ["Exit", null], ["Reason", "exit_reason"], ["Net P&L", "net_pnl"], ["R", "r_multiple"], ["Status", null],
  ["Data", null], ["Gross", "gross_pnl"], ["Costs", null], ["Partial", null], ["Hold (min)", "holding_minutes"], ["MFE", null], ["MAE", null],
];
